import styled from '@themes/theme'

export const SettingLimitWrap = styled.div`
  min-height: calc(100vh - 45px);
  height: 100%;
  overflow-y: auto;
  padding-bottom: 60px;
  text-align: left;
  background: ${props => props.theme.color.modalBg};
  &.pc-setting-limit {
    min-height: 100%;
  }
  .loss-money {
    padding: 40px 20px 30px;
    border-bottom: 1px solid ${props => props.theme.color.modalSubBg};
    ul {
      margin-bottom: 20px;
      padding: 14px 28px;
      background: ${props => props.theme.color.modalSubBg};
      border-radius: 14px;
    }
    .limit-money {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 32px;
      color: ${props => props.theme.color.modalTxt};
      .limit-txt {
        width: auto;
        min-width: 50px;
        font-size: ${props => props.theme.font.large};
        color: ${props => props.theme.color.modalTxt};
      }
      .money-area {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 32px;
        padding: 8px;
        color: ${props => props.theme.color.modalTxt};
        font-size: ${props => props.theme.font.large};
        &:first-of-type {
          margin-bottom: 4px;
        }
        input {
          flex: 1;
          max-width: 100px;
          height: 50px;
          padding: 0;
          text-align: right;
          color: ${props => props.theme.color.modalTxt};
          background: none;
          border: none;
          &::placeholder {
            color: #ACACAC !important;
            opacity: 1; /* Firefox */
          }
        }
        svg {
          width: 18px;
          margin-left: 6px;
        }
      }
      &.setting-limit {
        margin-top: 6px;
        border-radius: 25px;
        .money-area {
          background: ${props => props.theme.color.modalBg};
          border-radius: 50px;
        }
      }
    }
  }
  .setting-term {
    padding: 30px 20px;
    .limit-setting {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 60px;
      margin-bottom: 20px;
      padding: 0 28px;
      background: ${props => props.theme.color.modalSubBg};
      border-radius: 14px;
      .limit-txt {
        font-size: ${props => props.theme.font.large};
        color: ${props => props.theme.color.modalTxt};
      }
    }
  }
  .explain-box {
    padding: 0 25px;
    .explain-tit {
      color: ${props => props.theme.color.modalTxt};
      & + .explain-txt {
        margin-bottom: 9px;
      }
    }
    .explain-txt {
      font-weight: ${props => props.theme.fontW.medium};
      color: ${props => props.theme.color.modalSubTxt};
    }
    p.point-color--red--modal {
      font-weight: ${props => props.theme.fontW.medium};
    }
  }
  .change-btn {
    display: block;
    margin: 0 auto;
    width: 180px;
    height: 40px;
  }
`
